import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { site } from '../data/site';
import { serviceLinks } from '../data/services';
const companyLinks = [{
  label: 'Home',
  to: '/'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Reviews',
  to: '/reviews'
}, {
  label: 'Contact',
  to: '/contact'
}, {
  label: 'Our Work',
  to: '/#work'
}];
export function Footer() {
  return <footer className="bg-ink pb-24 pt-16 text-white lg:pb-10" data-id="element-155" data-mp="3uesczotj1hl9">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:grid-cols-2 lg:grid-cols-[1.2fr_0.6fr_1.7fr] lg:px-8" data-id="element-156" data-mp="38qw2zmvrtrp">
        <div data-id="element-157" data-mp="3lelz41tx2flk">
          <Logo badge data-id="element-158" data-mp="3lf58uv9exxoi" />
          <p className="mt-5 max-w-sm text-white/65" data-id="element-159" data-mp="3ldkgncakmqtt">
            Quality, affordable home maintenance and repair for the Las Vegas Valley. Local and family-owned.
          </p>
          <a href={site.phoneHref} className="mt-5 inline-block font-display text-3xl font-bold text-brand" data-id="element-160" data-mp="29yxbr9cr3ek8">
            {site.phone}
          </a>
          <p className="mt-2 text-sm text-white/60" data-id="element-161" data-mp="2ew70snw89o7j">{site.location}</p>
        </div>
        <nav aria-label="Company" data-id="element-162" data-mp="3l9sjf6xt4wpj">
          <p className="font-display text-lg font-bold uppercase text-white/50" data-id="element-163" data-mp="3gah1vvpm9n6w">Company</p>
          <ul className="mt-4 space-y-2.5" data-id="element-164" data-mp="3v7q63q00qlg1">
            {companyLinks.map(l => <li key={l.to} data-id="element-165" data-mp="3v5n6ce92ddy4">
                <Link to={l.to} className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-166" data-mp="3q8wts0wgx0hg">
                  {l.label}
                </Link>
              </li>)}
          </ul>
        </nav>
        <nav aria-label="Services" className="sm:col-span-2 lg:col-span-1" data-id="element-167" data-mp="34p8v6p2nshq">
          <p className="font-display text-lg font-bold uppercase text-white/50" data-id="element-168" data-mp="hsk2cpawm0vv">Services</p>
          <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-169" data-mp="ctqrl4n04nze">
            {serviceLinks.map(s => <li key={s.slug} data-id="element-170" data-mp="qt049uc00zym">
                <Link to={`/${s.slug}`} className="text-white/80 transition-colors duration-150 hover:text-white" data-id="element-171" data-mp="qub9zzp08hsd">
                  {s.name}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col justify-between gap-2 border-t border-white/10 px-5 pt-6 text-sm text-white/50 sm:flex-row lg:px-8" data-id="element-172" data-mp="tt9z0dyrgtw6">
        <p data-id="element-173" data-mp="13sirf2dza0gf">© {new Date().getFullYear()} Home Repair, MD. All rights reserved.</p>
        <p data-id="element-174" data-mp="18k92jakqos8w">{site.license}</p>
      </div>
    </footer>;
}